module.exports = __webpack_public_path__ + "static/media/6.22388daf.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hats/400/6.png
// module id = 1322
// module chunks = 0